import api from './PowerShadesAPI';

type typedApiType = { [key: string]: (...args) => Promise<any> };

const typedApi = api as any as typedApiType;

export default typedApi;
